import React from 'react'

import Users, { LoaderUsers } from './views/users/Users'
import UsersForm, { LoaderUsersUpdate } from './views/users/UsersForm'

import Accounts, { LoaderAccounts } from './views/accounts/Accounts'
import AccountsForm, { LoaderAccountsUpdate } from './views/accounts/AccountsForm'
import Media, { LoaderMedia } from './views/media/Media';

import Home, { LoaderHome } from './views/home/Home'

import Workers, { LoaderWorkers } from './views/workers/Workers'
import WorkersForm, { LoaderWorkersUpdate } from './views/workers/WorkersForm'
import MyJobs, { LoaderMyJobs } from './views/myJobs/MyJobs'
import MyJobsForm, { LoaderMyJobsUpdate } from './views/myJobs/MyJobsForm'
import Faq, { LoaderFaq } from './views/faq/faq';
import FaqForm, { LoaderFaqUpdate } from './views/faq/faqForm';
import InstructionMedia, { LoaderInstructionMedia } from './views/instructionMedia/InstructionMedia'
import SpecialMachines, { LoaderSpecialMachines } from './views/special-machines/SpecialMachines'
import SpecialMachinInformation, { LoaderSpecialMachinInformation } from './views/special-machines/SpecialMachinInformation'
import MyDirectives, { LoaderMyDirectives } from './views/directives/MyDirectives'
import MyDirectivesForm, { LoaderDirectivesUpdate } from './views/directives/MyDirectivesForm'
import JobTools, { LoaderJobTools } from './views/job_tools/JobTools'
import WorkPlan, { LoaderWorkPlanUpdate } from './views/work_plan/WorkPlan'
import WorkSchedules, { LoaderWorkSchedules } from './views/work_plan/WorkSchedules'
import PlanStages from './views/plan_data/PlanStages'
import PlanTypes from './views/plan_data/PlanTypes'
import PlanSafetyMeasures from './views/plan_data/PlanSafetyMeasures'
import WorkPlans, { LoaderWorkPlans } from './views/work_plan/WorkPlans'
import WorkScheduleGantt, { LoaderWorkSchedulesUpdate } from './views/work_plan/WorkScheduleGantt'
import WorkPlanStages, { LoaderStagesLists } from './views/plan_stages/WorkPlanStages'
import WorkPlanStagesForm, { LoaderPlanStagesUpdate } from './views/plan_stages/WorkPlanStagesForm'
import WorkPlanTypes, { LoaderTypesLists } from './views/plan_types/WorkPlanTypes'
import WorkPlanTypesForm, { LoaderPlanTypesUpdate } from './views/plan_types/WorkPlanTypesForm'
import WorkPlanSafetyMeasures, { LoaderSafetyMeasuresLists } from './views/plan_safety_measures/WorkPlanSafetyMeasures'
import WorkPlanSafetyMeasuresForm, { LoaderSafetyMeasuresListsUpdate } from './views/plan_safety_measures/WorkPlanSafetyMeasuresForm'

// Notifications
const Login = React.lazy(() => import('./views/pages/login/Login'))

/** ASD ROUTERS */

const routes = [
  { path: '/', exact: true, name: 'Home', element: <Home />, loader: LoaderHome },
  { path: '/login', name: 'Логін', element: <Login /> },

  { path: '/accounts', name: 'Контрагенти', element: <Accounts />, loader: LoaderAccounts },
  {
    path: '/accounts/create',
    name: 'Створити контрагента',
    element: <AccountsForm />,
    loader: LoaderAccountsUpdate,
  },
  {
    path: '/accounts/update/:pid',
    name: 'Редагувати контрагента',
    element: <AccountsForm />,
    loader: LoaderAccountsUpdate,
  },

  { path: '/workers', name: 'Працівники', element: <Workers />, loader: LoaderWorkers },
  {
    path: '/workers/create',
    name: 'Додати працівника',
    element: <WorkersForm />,
    loader: LoaderWorkersUpdate,
  },
  {
    path: '/workers/update/:pid',
    name: 'Редагувати працівника',
    element: <WorkersForm />,
    loader: LoaderWorkersUpdate,
  },

  { path: '/users', name: 'Користувачі', element: <Users />, loader: LoaderUsers },
  {
    path: '/users/create',
    name: 'Створити користувача',
    element: <UsersForm />,
    loader: LoaderUsersUpdate,
  },
  {
    path: '/users/update/:pid',
    name: 'Редагувати користувача',
    element: <UsersForm />,
    loader: LoaderUsersUpdate,
  },

  { path: '/special-machines', name: 'Спецтехніка', element: <SpecialMachines />, loader: LoaderSpecialMachines },
  {
    path: '/special-machines/read/:pid',
    name: 'Переглянути спецтехніку',
    element: <SpecialMachinInformation />,
    loader: LoaderSpecialMachinInformation,
  },

  { path: '/jobs', name: 'Роботи', element: <MyJobs />, loader: LoaderMyJobs },
  {
    path: '/jobs/create',
    name: 'Створити роботу',
    element: <MyJobsForm />,
    loader: LoaderMyJobsUpdate,
  },
  {
    path: '/jobs/update/:pid',
    name: 'Редагувати користувача',
    element: <MyJobsForm />,
    loader: LoaderMyJobsUpdate,
  },

  // { path: '/faq', name: 'FAQ', element: <Faq />, loader: LoaderFaq },
  // { path: '/faq/create', name: 'Створити FAQ', element: <FaqForm />, loader: LoaderFaqUpdate },
  // { path: '/faq/update/:pid', name: 'Редагувати FAQ', element: <FaqForm />, loader: LoaderFaqUpdate },


  { path: '/instruction', name: 'Інструкція', element: <InstructionMedia />, loader: LoaderInstructionMedia },

  { path: '/directives', name: 'Приписи', element: <MyDirectives />, loader: LoaderMyDirectives },
  // { path: '/directives/create', name: 'Створити FAQ', element: <FaqForm />, loader: LoaderFaqUpdate },
  { path: '/directives/update/:pid', name: 'Припис', element: <MyDirectivesForm />, loader: LoaderDirectivesUpdate },

  {
    path: '/job_tools', name: 'Інструменти', element: <JobTools />,
    loader: LoaderJobTools
  },
  //зміни до ворк плану 14.11.25
  {
    path: '/work_plans', name: 'Плани робіт', element: <WorkPlans />
    , loader: LoaderWorkPlans
  },

  {
    path: '/work_plans/update/:pid',
    name: 'Редагувати План Робіт',
    element: <WorkPlan />,
    loader: LoaderWorkPlanUpdate,
  },

  {
    path: '/work_plans/create',
    name: 'Створити План Робіт',
    element: <WorkPlan />,
    loader: LoaderWorkPlanUpdate,
  },

  {
    path: '/work_plan', name: 'План Робіт', element: <WorkPlan />,
    // loader: LoaderJobTools
  },
  {
    path: '/work_graphs', name: 'Графіки Робіт', element: <WorkSchedules />,
    loader: LoaderWorkSchedules
  },
  {
    path: '/work_graphs/create',name: 'Створити Графік Робіт', element: <WorkScheduleGantt />, loader: LoaderWorkSchedulesUpdate,
  },
  {
    path: '/work_graphs/view/:pid', name: 'Перегляд графіку', element: <WorkScheduleGantt />,
    loader: LoaderWorkSchedulesUpdate
  },

  // роути для довідників плану робіт

  //для етапів
  //сторінка всих етапів
  {
    path: '/work_stages_lists', name: 'Довідник етапів', element: <WorkPlanStages />,
    loader: LoaderStagesLists
  },
  //сторінка додавання етапу до списку
  {
    path: '/work_stages_lists/create', name: 'Додати новий етап до довідника', element: <PlanStages />,
    // loader: LoaderJobTools
  },
  //сторінка редагування етапу  списку
  {
    path: '/work_stages_lists/update/:pid', name: 'Редагувати етап', element: <WorkPlanStagesForm />,
    loader: LoaderPlanStagesUpdate
  },

  //для типів
  //сторінка всих типів
  {
    path: '/work_types_lists', name: 'Довідник типів', element: <WorkPlanTypes />,
    loader: LoaderTypesLists
  },
  //сторінка додавання типу до списку
  {
    path: '/work_types_lists/create', name: 'Додати новий тип до довідника', element: <PlanTypes />,
    // loader: LoaderJobTools
  },
  //сторінка редагування типу  списку
  {
    path: '/work_types_lists/update/:pid', name: 'Редагувати тип', element: <WorkPlanTypesForm />,
    loader: LoaderPlanTypesUpdate
  },

  {
    path: '/plan_safety_measures', name: 'Графік Робіт', element: <PlanSafetyMeasures />,
    // loader: LoaderJobTools
  },

  //для заходів ОП
  //сторінка всих заходів ОП
  {
    path: '/safety_measures_lists', name: 'Довідник заходів з ОП', element: <WorkPlanSafetyMeasures />,
    loader: LoaderSafetyMeasuresLists
  },
  //сторінка додавання заходу з ОП до списку
  {
    path: '/safety_measures_lists/create', name: 'Додати новий захід з ОП до довідника', element: <PlanSafetyMeasures />,
    // loader: LoaderJobTools
  },
  //сторінка редагування заходу з ОП 
  {
    path: '/safety_measures_lists/update/:pid', name: 'Редагувати захід з ОП', element: <WorkPlanSafetyMeasuresForm />,
    loader: LoaderSafetyMeasuresListsUpdate
  },


]

export default routes
